import { useEventsContext } from '../../../context/events/EventsContext';
import { useDeleteClipsMutation } from '../operation.generated';
import { EventName } from '../../../services/EventTrackingService';

const useOptimisticDeleteClips = (
  options: Parameters<typeof useDeleteClipsMutation>[0] = {}
) => {
  const [eventTracking] = useEventsContext();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return useDeleteClipsMutation({
    optimisticResponse: ({ inputs: { clipIds } }) => ({
      deleteClips: {
        __typename: 'DeleteClipsMutationResponse',
        success: true,
        code: 'graphql_mutation_success',
        message: 'Deleted clips successfully',
        numClipsDeleted: clipIds.length,
        numClipsRecredited: 0,
        // satisfy apollo cache
        clips: null,
        userProductAccessPeriodUsage: null,
        teamProductAccessPeriodUsage: null,
      },
    }),
    onCompleted: data => {
      if (data.deleteClips.success) {
        const { numClipsDeleted, numClipsRecredited } = data.deleteClips;
        eventTracking.track({
          type: EventName.BatchClipsDelete,
          data: {
            total: numClipsDeleted ?? 0,
            numRecredited: numClipsRecredited ?? 0,
          },
        });
      }
    },
    ...options,
  });
};

export default useOptimisticDeleteClips;
